module.exports = __webpack_public_path__ + "img/Patch9-2.10a77ed6.webp";